import { render, staticRenderFns } from "./archived.vue?vue&type=template&id=78dbfb6e&scoped=true&"
import script from "./archived.vue?vue&type=script&lang=js&"
export * from "./archived.vue?vue&type=script&lang=js&"
import style0 from "./archived.vue?vue&type=style&index=0&id=78dbfb6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dbfb6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VContainer,VIcon})
